module.exports = __webpack_public_path__ + "img/my-business.2c28c02e.png";